/* eslint-disable class-methods-use-this */
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import React from 'react';
import { Text, Link } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import { mediaQueries, colors } from 'style/config';
import PazePaymentMethodEN from 'components/Paze/PazePaymentMethod/locales/PazePaymentMethod_en_US';
import PazePaymentMethodFR from 'components/Paze/PazePaymentMethod/locales/PazePaymentMethod_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(PazePaymentMethodEN, PazePaymentMethodFR);

class PazePaymentMethod extends BaseClass {
    componentDidMount() {
        const { loadIframe, errorMessage } = this.props;
        loadIframe({ errorMessage });
    }

    render() {
        const iframeURL = Sephora.configurationSettings.pazeIframe;
        const { isFrictionless, frameStyles = {}, legacyTextStyles = {} } = this.props;

        return (
            <>
                <iframe
                    css={{ ...styles.iframe, ...frameStyles }}
                    src={iframeURL}
                ></iframe>
                <Text
                    is='p'
                    fontSize='xs'
                    css={{ ...legacyTextStyles }}
                    {...(isFrictionless && { marginBottom: [2, 1], marginTop: 4 })}
                >
                    {getText('legalNotice')}
                    <Link
                        color={colors.blue}
                        href='https://www.paze.com/service-agreement'
                    >
                        {getText('pazeTerms')}
                    </Link>
                    {getText('legalNotice02')}
                    <Link
                        color={colors.blue}
                        href='https://www.paze.com/service-privacy-notice'
                    >
                        {getText('pazePolicy')}
                    </Link>
                    .
                </Text>
            </>
        );
    }
}

const styles = {
    iframe: {
        height: '310px',
        width: '80%',
        [mediaQueries.xsMax]: {
            width: '100%'
        }
    }
};

export default wrapComponent(PazePaymentMethod, 'PazePaymentMethod', true);
